module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"localeJsonSourceName":"locale","languages":["en","es"],"defaultLanguage":"en","useLangKeyLayout":false,"prefixDefault":false,"i18nextOptions":{"debug":false,"fallbackLng":"en","interpolation":{"skipOnVariables":false,"escapeValue":false},"keySeparator":".","nsSeparator":"::","react":{"transSupportBasicHtmlNodes":true,"transKeepBasicHtmlNodesFor":["br","strong","em","cite","i","p","h1","h2","h3","h4","a","b","ul","li"]}}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
